import {
  BrandAndMarketListItem,
  Carriers,
  CodeAndLabel,
  FareBasisCode,
  FormDataRouteRestriction,
  RuleFormDataAgencyOrGroup,
  SearchTravelRange,
  DateTimeRestrictionData,
} from '../../../integrated-client/models';

export interface IGlobalFiltersV2EditorData {
  id?: string | null;
  allowEdit?: boolean;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  brandAndMarket?: BrandAndMarketListItem;
  relevance?: number;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  providers?: Array<string> | null;
  fareTypes?: Array<CodeAndLabel> | null;
  carriers?: Array<Carriers> | null;
  carriersMatch?: boolean | null;
  fareBases?: Array<FareBasisCode> | null;
  effectiveFrom?: any; // TODO: type once API contract is confirmed
  effectiveTo?: any; // TODO: type once API contract is confirmed
  allow?: any;
  multiAirportConnectionsMatch?: boolean | null;
  doubleConnectionsMatch?: boolean | null;
  baglessFaresMatch?: boolean | null;
  mixAndMatchProviders?: Array<string> | null;
  marketingFlightNumbers?: Array<string> | null;
  marketingFlightNumbersMatch?: boolean | null;
  bookingClasses?: string[] | null;
  bookingClassesMatch?: boolean | null;
  fareBasesMatch?: boolean | null;
  accountCodes?: Array<string> | null;
  maxConnectionTimeFrom?: string | null;
  maxConnectionTimeTo?: string | null;
  travelDates?: Array<SearchTravelRange> | null;
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  cloneSourceId?: string | null;
}

export interface IEditorData {
  globalFiltersV2EditorData: IGlobalFiltersV2EditorData;
  validation?: any;
  readyToSave: boolean;
}

export class GlobalFiltersV2EditorData implements IGlobalFiltersV2EditorData {
  id?: string | null;
  allowEdit?: boolean;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  brandAndMarket?: BrandAndMarketListItem;
  relevance?: number;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  providers?: Array<string> | null;
  fareTypes?: Array<CodeAndLabel> | null;
  carriers?: Array<Carriers> | null;
  carriersMatch?: boolean | null;
  fareBases?: Array<FareBasisCode> | null;
  effectiveFrom?: any; // TODO: type once API contract is confirmed
  effectiveTo?: any; // TODO: type once API contract is confirmed
  allow?: any;
  multiAirportConnectionsMatch?: boolean | null;
  doubleConnectionsMatch?: boolean | null;
  baglessFaresMatch?: boolean | null;
  mixAndMatchProviders?: Array<string> | null;
  marketingFlightNumbers?: Array<string> | null;
  marketingFlightNumbersMatch?: boolean | null;
  bookingClasses?: string[] | null;
  bookingClassesMatch?: boolean | null;
  fareBasesMatch?: boolean | null;
  accountCodes?: Array<string> | null;
  maxConnectionTimeFrom?: string | null;
  maxConnectionTimeTo?: string | null;
  travelDates?: Array<SearchTravelRange> | null | undefined;
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  cloneSourceId?: string | null;

  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  globalFiltersV2EditorData: IGlobalFiltersV2EditorData;
  validation?: any;
  readyToSave: boolean;

  constructor() {
    this.globalFiltersV2EditorData = new GlobalFiltersV2EditorData();
    this.readyToSave = false;
  }
}
